import { usePhoto } from '../api/hooks.ts'
import { initials } from '../lib/status.ts'

// Аватар — «скруглённый квадрат» из логотипа с инициалами. Монохромные тона по id.
// Если сотрудник загрузил фото (и нам его можно видеть) — показываем фото.

interface AvatarProps {
  name: string
  id?: number
  size?: number
  /** Версия фото профиля; null/undefined — фото нет. */
  photo?: number | null
}

export function Avatar({ name, id = 0, size = 36, photo }: AvatarProps) {
  const tone = Math.abs(id) % 5
  const src = usePhoto(id, photo).data
  if (src) {
    return (
      <img
        className="avatar avatar--photo"
        src={src}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
    )
  }
  return (
    <span
      className={`avatar avatar--t${tone}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      aria-hidden="true"
    >
      {initials(name)}
    </span>
  )
}
